module.exports = __webpack_public_path__ + "static/img/lost-ethereal-pixel-art-low-res-retro-8bit-desert.71a34a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/lost-ethereal/lost-ethereal-pixel-art-low-res-retro-8bit-desert.png
// module id = qDqw
// module chunks = 0